/**
 * API endpoint configuration for organization resources.
 * Maps resource keys to their API endpoint paths.
 */
export const ORGANIZATION_ENDPOINTS = {
  status: 'status',
  generalData: 'general-data',
  contacts: 'contacts',
  fattureElettronicheXml: 'fatture-elettroniche-xml',
  fattureCartaceePdf: 'fatture-cartacee-pdf',
  scrittureLibriContabili: 'scritture-libri-contabili',
  altriDocumentiRilevanzaContabile: 'altri-documenti-rilevanza-contabile',
  dichiarazioniComunicazioniFisco: 'dichiarazioni-comunicazioni-fisco',
  messaggiPec: 'messaggi-posta-elettronica-certificata-pec',
  libroUnicoLavoro: 'libro-unico-del-lavoro-lul',
  altreTipologieDocumentali: 'altre-tipologie-documentali',
  rentri: 'rentri',
  notify: 'notify',
  accept: 'accept',
  reject: 'reject',
  verifyData: '/api/verify-data',
  sendEmail: '/api/verify-data/send-emails',
} as const;

export type OrganizationEndpointKey = keyof typeof ORGANIZATION_ENDPOINTS;
